import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk";
import SeoHead from "../../components/SeoHead";
import { Helmet } from "react-helmet";
import LatestNews from "../../components/LatestNews";
import { Container } from "reactstrap";
import NewBlogDetails from "../../components/NewBlogDetails";
import NewSubBanner from "../../components/NewSubBanner";
import NewColumnWithForm from "../../components/NewColumnWithForm";
import NewBlogDetails2 from "../../components/NewBlogDetails2";

export default function InsightPage({ global, page, all_news, related_news }) {
  // Define the breadcrumbList array
  const breadcrumbList = [
    {
      "@type": "ListItem",
      name: "Lorien",
      position: 1,
      item: {
        "@type": "Thing",
        "@id": `https://www.lorienglobal.com/`,
      },
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Insights",
      item: {
        "@type": "Thing",
        "@id": `https://www.lorienglobal.com/insights`,
      },
    },
  ];

  return (
    <>
      <SeoHead
        page_name={`${page.title} | The global house of tech and transformation recruitment | Lorien`}
        canonical_link={`insights/${page.url_slug}`}
        og_image={page.image}
        og_img_alt={`${page.title}`}
        removeUSHrefLang={
          page.country?.includes("United States") ||
          page.country?.includes("All")
            ? false
            : true
        }
      />
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: breadcrumbList,
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            description: page?.short_description || "",
            isFamilyFriendly: "http://schema.org/True",
            image: page?.image || "",
            dateModified: page?.updated_at || "",
            datePublished: page?.created_at || "",
            name: page?.title || "",
            headline: page?.title || "",
            articleBody: page?.content
              ? page.content.replace(/<[^>]*>/g, "")
              : "",
            publisher: {
              "@type": "Organization",
              name: "Lorien",
              sameAs: "https://www.lorienglobal.com/",
              logo: {
                "@type": "ImageObject",
                url: "https://cdn.sourceflow.co.uk/wijxmc47ccusm0jll37684eh7usc",
              },
            },
            author: {
              "@type": "Person",
              image: page?.author_image || "",
              name: page?.author || "",
            },
          })}
        </script>
      </Helmet>
      <NewSubBanner
        global={global}
        pathPrefix={`${page.url_slug}.insights_page.main_banner`}
        customClass={``}
        content={
          <>
            <h1>{page.title}</h1>
          </>
        }
        imageURL1={`/site-assets/images/main-banner.jpg`}
        imageALT1={`Main Banner`}
        imageURL2={`/site-assets/images/sub-banner-insights.png`}
        imageALT2={`Overlay Main Banner`}
        displayImage1={false}
        editableContent={false}
        buttonLink={`${
          page.tag.includes("Case Study")
            ? "/insights/tag/case-study"
            : page.tag.includes("Guides & Reports")
            ? "/insights/tag/guides-and-reports"
            : "/insights"
        }`}
        buttonTitle={`${
          page.tag.includes("Case Study")
            ? "Back to Case Study"
            : page.tag.includes("Guides & Reports")
            ? "Back to Guides & Reports"
            : "Back to insights"
        }`}
        post={page}
        buttonLink2={`${
          page.tag.includes("Guides & Reports") && page?.form_id ? "#download-form" : ""
        }`}
        buttonTitle2={`${
          page.tag.includes("Guides & Reports") && page?.form_id ? "Download Report" : ""
        }`}
      />
      {page.tag.includes("Guides & Reports") ||  page.tag.includes("News & Insights") ? (
        <NewBlogDetails
          global={global}
          pathPrefix={`insights_page.guides_and_reports.new_blog_details`}
          page={page}
          related_news={related_news}
          page_prefix={`insights`}
          share_heading={`Share Report`}
          className={`py-5 guides-and-reports-page`}
          formId={page?.form_id}
          locale={``}
          successPageUrl={
            page.form_link
              ? page.form_link
              : page.form_attachment
              ? page.form_attachment
              : "/submission-success"
          }
        />
      ) : page.tag.includes("Case Study") ? (
        page.case_study_tabs?.length >= 1 && (
          <>
            <NewBlogDetails2
              global={global}
              pathPrefix={`insights_page.new_blog_details_2`}
              page={page}
            />
          </>
        )
      ) : (
        <NewBlogDetails
          global={global}
          pathPrefix={`insights_page.new_blog_details`}
          page={page}
          related_news={related_news}
          page_prefix={`insights`}
          locale={``}
        />
      )}
      {page.tag.includes("Guides & Reports") ||
      page.tag.includes("Case Study") ? (
        <>
          <Container>
            <hr></hr>
          </Container>
          <LatestNews
            global={global}
            pathPrefix={`${page.url_slug}.insights_page.guides_and_reports.latest_news`}
            customClass={`py-5 white-card`}
            post={all_news}
            content={
              <>
                <h2>
                  {page.tag.includes("Guides & Reports")
                    ? "Other Guides and Reports"
                    : "Other Case Studies"}
                </h2>
              </>
            }
            buttonLink={``}
            buttonTitle={``}
            content_align={`left`}
            footer_buttonLink={`/insights${
              page.tag.includes("Guides & Reports")
                ? "/insights/tag/guides-and-reports"
                : "/tag/case-study"
            }`}
            footer_buttonLink_title={`View All`}
          />
        </>
      ) : (
        ""
      )}
      <NewColumnWithForm
        global={global}
        pathPrefix={`${page.url_slug}.insights_page.new_column_with_form`}
        customClass={`pb-5`}
        heading={`How can we help you?`}
        formId={
       `308d12ba-6cc4-44a5-91e2-76d1d714bf23`
        }
        successPageUrl={
          page.form_link
            ? page.form_link
            : page.form_attachment
            ? page.form_attachment
            : "/submission-success"
        }
        //UK - New General Inquiry Form
      />
    </>
  );
}

export async function getStaticProps({ params }) {
  const global = (await Global()).toJson();
  const page = (await Collection("news")).getJsonItem(
    params.url_slug,
    "url_slug"
  );

  const news = (await Collection("news"))
    .filter(function (post) {
      return post.country?.en == "United Kingdom" || post.country?.en == "All";
    })
    .filter(function (post) {
      return (
        Array.isArray(post.tag?.en) &&
        post.tag.en.some((tag) => page.tag?.includes(tag))
      );
    });

  const all_news = news.orderBy("order").getItems().slice(0, 8);

  const related_news = news.orderBy("order").getItems().slice(0, 2);

  return {
    props: {
      global,
      page,
      all_news,
      related_news,
    },
  };
}

export async function getStaticPaths() {
  const pagePath = (await Collection("news"))
    .filter(function (post) {
      return post.country?.en == "United Kingdom" || post.country?.en == "All";
    })
    .getPaths("url_slug");

  return {
    paths: pagePath,
    fallback: false,
  };
}
